module.exports = {
  FONT_FAMILY: 'BlinkMacSystemFont, "Segoe UI", Roboto,"Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",SimSun, "sans-serif"'
};


//////////////////
// WEBPACK FOOTER
// ./src/const.js
// module id = 9
// module chunks = 0